import React, { useState } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import Seo from "../seo/Seo";
import { PageHero, CTASection } from "../components/ui-kit";
import { IMAGES } from "../mock/mock";
import { FEATURED_HOMES } from "../data/site";

const breadcrumbs = [{ name: "Home", path: "/" }, { name: "Projects", path: "/projects" }];

const Projects = () => {
  const [active, setActive] = useState(null);
  const close = () => setActive(null);
  const move = (d) => setActive((a) => (a + d + FEATURED_HOMES.length) % FEATURED_HOMES.length);
  return (
    <>
      <Seo
        title="Featured Custom Homes & Projects | Build Highland Homes"
        description="Browse featured custom homes and craftsmanship by Build Highland Homes across Central Florida — custom home construction, additions, and custom interiors."
        path="/projects"
        keywords="custom home projects, featured custom homes, custom home builder portfolio central florida"
        breadcrumbs={breadcrumbs}
      />
      <PageHero overline="Our Work" title="Featured Custom Homes" subtitle="A selection of custom homes, additions, and craftsmanship from Build Highland Homes across Central Florida." image={IMAGES.hero} />

      <section className="py-16 md:py-24 bg-[#0b0b0b]">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
            {FEATURED_HOMES.map((h, i) => (
              <button key={i} onClick={() => setActive(i)} className="relative group overflow-hidden">
                <img src={IMAGES[h.image]} alt={`${h.title} — custom home by Build Highland Homes`} loading="lazy" decoding="async" className="w-full h-48 md:h-56 object-cover transition-transform duration-700 group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 to-transparent opacity-80 group-hover:opacity-100 transition-opacity" />
                <div className="absolute bottom-0 left-0 p-4 text-left">
                  <span className="text-[#e3c77a] text-[10px] tracking-[0.2em] uppercase">{h.category}</span>
                  <h3 className="font-serif-display text-lg text-[#f3ede0]">{h.title}</h3>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {active !== null && (
        <div className="fixed inset-0 z-[60] bg-black/95 flex items-center justify-center p-4" onClick={close}>
          <button onClick={close} className="absolute top-6 right-6 text-[#f3ede0] hover:text-[#c9a24b]"><X size={32} /></button>
          <button onClick={(e) => { e.stopPropagation(); move(-1); }} className="absolute left-4 md:left-10 text-[#f3ede0] hover:text-[#c9a24b]"><ChevronLeft size={44} /></button>
          <div className="max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <img src={IMAGES[FEATURED_HOMES[active].image]} alt={FEATURED_HOMES[active].title} className="w-full max-h-[80vh] object-contain" />
            <p className="text-center font-serif-display text-2xl text-[#f3ede0] mt-4">{FEATURED_HOMES[active].title}</p>
          </div>
          <button onClick={(e) => { e.stopPropagation(); move(1); }} className="absolute right-4 md:right-10 text-[#f3ede0] hover:text-[#c9a24b]"><ChevronRight size={44} /></button>
        </div>
      )}

      <CTASection />
    </>
  );
};

export default Projects;
